import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/**
 * Shared CKEditor 5 (classic build) config.
 * Omits image, table, and media embed toolbar actions.
 */
export const CKEDITOR_CONFIG = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    'blockQuote',
    '|',
    'undo',
    'redo',
  ],
};

ClassicEditor.defaultConfig = {
  ...ClassicEditor.defaultConfig,
  ...CKEDITOR_CONFIG,
};

export const mergeCkeditorConfig = (overrides = {}) => ({
  ...CKEDITOR_CONFIG,
  ...overrides,
});
